import { useMyFinancialStatement } from "api/Client/balance";
import InputSearch, {
  DateInput,
  SelectInput,
} from "components/ClientLayoutPages/ClientInputField/InputsFilter";
import Container from "components/ClientLayoutPages/Container/Container";
import MyFinancialStatementModal from "components/Modal/Client/MyFinancialStatementModal/MyFinancialStatementModal";
import SkeletonMyOrder from "components/SkeletonList/SkeletonMyOrder";
import { useEffect, useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa"; // أيقونات من FontAwesome
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { GiSandsOfTime, GiTakeMyMoney } from "react-icons/gi";
import { GrCart } from "react-icons/gr";
import { MdNumbers } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
export default function FinancialStatement() {
  const [openMyFinancialStatementModal, setOpenMyFinancialStatementModal] =
    useState(false);
  const [currentId, setCurrentId] = useState(null);

  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(12);

  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const {
    data: myFinancialStatement,
    isFetching: myFinancialStatementIsLoading,
    isSuccess: myOrdersIsSuccess,
  } = useMyFinancialStatement(
    limit,
    pageNumber,
    searchValue,
    status,
    fromDate,
    toDate
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pageNumber]);

  return (
    <Container title={`البيان المالي`}>
      <div className="grid sm:grid-cols-1 grid-cols-2 md:grid-cols-4 bg-mainLight/20 p-4 pt-2 rounded-lg mb-8 mt-4 gap-4 mx-auto">
        <InputSearch
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          setPageNumber={setPageNumber}
        />
        <SelectInput
          value={status}
          setValue={setStatus}
          setPageNumber={setPageNumber}
          options={[
            { value: "approved", label: "مكتمل" },
            { value: "rejected", label: "مرفوضة" },
            { value: "pending", label: "انتظار" },
          ]}
        />
        <DateInput
          title={"من تاريخ"}
          value={fromDate}
          setValue={setFromDate}
          setPageNumber={setPageNumber}
        />
        <DateInput
          title={"الى تاريخ"}
          value={toDate}
          setValue={setToDate}
          setPageNumber={setPageNumber}
        />
      </div>

      {myFinancialStatementIsLoading && <SkeletonMyOrder number={6} />}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {!myFinancialStatementIsLoading &&
          myOrdersIsSuccess &&
          myFinancialStatement.data?.financial.length > 0 &&
          myFinancialStatement.data.financial.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                setCurrentId(item.id);
                setOpenMyFinancialStatementModal(true);
              }}
              className="relative card-animation bg-mainLight/20 cursor-pointer hover:scale-105 transition-transform duration-300 grid gap-1 h-60 text-white p-4 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl hover:bg-mainLight/40"
            >
              {/* <img
                src={logo}
                alt=""
                className="absolute z-10 w-40 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-20"
              /> */}

              <div className="flex justify-between items-center flex-row-reverse z-20">
                {" "}
                <h2
                  className="text-xl font-bold text-white"
                  style={{ direction: "ltr" }}
                >
                  {Number(Math.abs(item.amount)).toLocaleString()}{" "}
                  <span className="text-sm">
                    {item.order_type === "bankNotice"
                      ? item.currency_bank
                      : item.currency_customer}
                  </span>
                </h2>
                <div
                  className={`text-white items-center flex gap-3 ${
                    item.order_state === "pending"
                      ? "text-white"
                      : item.order_state === "approved"
                      ? "text-green-500"
                      : item.order_state === "rejected"
                      ? "text-red-500"
                      : "text-white"
                  }`}
                >
                  {item.order_state === "pending" ? (
                    <>
                      <div className="text-xl p-1 text-white">
                        <GiSandsOfTime />
                      </div>
                      <span className="font-bold">{"انتظار"}</span>
                    </>
                  ) : item.order_state === "approved" ? (
                    <>
                      <div className="text-xl p-1 text-green-500">
                        <FaCheck />
                      </div>
                      <span className="font-bold">{"مكتملة"}</span>
                    </>
                  ) : item.order_state === "rejected" ? (
                    <>
                      <div className="text-xl p-1 text-red-500">
                        <FaTimes />
                      </div>
                      <span className="font-bold">{"مرفوضة"}</span>
                    </>
                  ) : null}
                </div>
              </div>

              <div className={`text-white items-center flex gap-3 z-20`}>
                <div className="text-xl p-1 text-white">
                  <FaMoneyBillTransfer />
                </div>
                <span className="font-bold">
                  {item.order_type === "bankNotice"
                    ? "إيداع"
                    : item.order_type === "balanceRecharge"
                    ? "إيداع"
                    : item.order_type === "transaction"
                    ? "ارسال رصيد"
                    : item.order_type === "refund"
                    ? "مرتجع"
                    : item.order_type === "purchaseInvoice"
                    ? "سحب مبلغ"
                    : "- - -"}
                </span>
              </div>
              <div className={`text-white items-center flex gap-3 z-20`}>
                <div className="text-xl p-1 text-white">
                  <MdNumbers />
                </div>
                <span className="font-bold"> {item.id}</span>
              </div>
              <div className="text-white items-center text-sm flex gap-3 z-20">
                <div className="text-xl p-1 text-white">
                  {(item.order_type === "bankNotice" ||
                    item.order_type === "transaction" ||
                    item.order_type === "balanceRecharge") && <GiTakeMyMoney />}
                  {(item.order_type === "refund" ||
                    item.order_type === "purchaseInvoice") && <GrCart />}
                </div>
                <span className="font-bold line-clamp-2 overflow-hidden text-ellipsis">
                  {item.description}
                </span>
              </div>

              <div className="text-white items-center flex gap-3 z-20">
                <div className="text-xl p-1 text-white">
                  <SlCalender />
                </div>{" "}
                <span style={{ direction: "ltr" }} className="font-bold">
                  {" "}
                  {item.created_at}{" "}
                </span>
              </div>

              <div className="text-white items-center flex gap-3 z-20">
                <div className="text-lg_ font-bold p-1 text-white">
                  الرصيد قبل العملية
                </div>{" "}
                <span style={{ direction: "ltr" }} className="font-bold">
                  {Number(item.total_before_operation).toLocaleString()}{" "}
                  <span className="text-xs">
                    {item.currency_customer /* || "S.P" */}{" "}
                  </span>
                </span>
              </div>
            </div>
          ))}
      </div>

      {/* Pagination */}
      <div className="flex flex-col items-center mt-16 w-full">
        <span className="text-sm text-white flex gap-1">
          <span className="font-semibold">
            {myFinancialStatement?.data?.pagination?.current_page || 0}
          </span>
          <span className="font-medium">من اصل</span>
          <span className="font-semibold">
            {myFinancialStatement?.data?.pagination?.last_page || 0}
          </span>{" "}
        </span>
        <div className="flex gap-4 mt-2">
          <button
            onClick={() => setPageNumber((prev) => prev - 1)}
            disabled={pageNumber === 1 || myFinancialStatementIsLoading}
            className="btn btn-smart text-sm !p-1 w-20 "
          >
            السابق
          </button>
          <button
            onClick={() => setPageNumber((prev) => prev + 1)}
            disabled={
              myFinancialStatement?.data?.financial.length === 0 ||
              pageNumber >= myFinancialStatement?.data.pagination?.last_page ||
              myFinancialStatement?.data?.pagination?.total === 0 ||
              myFinancialStatementIsLoading
            }
            className="btn btn-smart text-sm !p-1 w-20 "
          >
            التالي
          </button>
        </div>
      </div>

      {openMyFinancialStatementModal && (
        <MyFinancialStatementModal
          isOpen={openMyFinancialStatementModal}
          toggle={setOpenMyFinancialStatementModal}
          financialId={currentId}
        />
      )}
    </Container>
  );
}
